import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import {
    PaymentsProps,
    PaymentsRequest,
} from '../../payments/service/payments.interface';
import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';
import { authHeader } from '../../../../../utils/common/authHeader';

export const adminFeedbackApi = createApi({
    reducerPath: 'adminFeedbackApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL + '/manager',
        prepareHeaders: (headers: Headers) => authHeader(headers),
    }),
    tagTypes: ['feedbacks'],
    endpoints: build => ({
        readFeedbacks: build.query<
            PaginatedResponse<PaymentsProps>,
            PaymentsRequest
        >({
            query: payload => {
                const queryArgs = qs.stringify(payload.filters, {
                    arrayFormat: 'bracket-separator',
                    skipNull: true,
                });
                return {
                    url: `/feed-backs?${queryArgs}`,
                };
            },
            transformResponse: (res: { data: PaymentsProps[] }, meta) => {
                return {
                    items: res.data || [],
                    total:
                        Number(meta.response.headers.get('Items-count')) || 0,
                };
            },

            providesTags: ['feedbacks'],
        }),
        closeFeedback: build.mutation<any, any>({
            query: (id: string) => ({
                url: `/feed-back/close/${id}`,
            }),
            invalidatesTags: ['feedbacks'],
        }),
        getFeedbackById: build.query({
            query: (id: string) => ({
                url: `/feed-back/show/${id}`,
            }),
            transformResponse: (res: { data: any }) => res?.data,
        }),
        answerFeedback: build.mutation({
            query: body => ({
                method: 'POST',
                url: 'feed-back/answer',
                body,
            }),
            invalidatesTags: ['feedbacks'],
        }),
    }),
});

export const {
    useCloseFeedbackMutation,
    useGetFeedbackByIdQuery,
    useLazyReadFeedbacksQuery,
    useAnswerFeedbackMutation,
} = adminFeedbackApi;
